const VITE_APP_DOMAIN =
  import.meta.env.MODE === "development" || import.meta.env.VITE_APP_TEST_MODE === "server"
    ? import.meta.env.VITE_APP_DOMAIN
    : `${origin}/`;

const API_BASE_URL = `${VITE_APP_DOMAIN}api/v1/`;
const API_BASE_URL_2 = `${VITE_APP_DOMAIN}api/v2/`;

export const API_LOCALE = `${import.meta.env.VITE_APP_DOMAIN}api/v1/locales`;

export const API_AUTH = `${API_BASE_URL}auth`;
export const API_SIGN_UP = `${API_BASE_URL}signup`;
export const API_LOGIN = `${API_BASE_URL}auth/login`;
export const API_RESETPASSWORD = `${API_BASE_URL}auth/reset_password`;
export const API_FORGOTPASSWORD = `${API_BASE_URL}auth/forgot_password`;
export const API_PROVIDER_SIGN_UP = (whichProvider: string) => `${API_SIGN_UP}/${whichProvider}`;
export const API_PROVIDER_LOGIN = (whichProvider: string) => `${API_LOGIN}/${whichProvider}`;

export const API_MY_PROFILE = `${API_BASE_URL}users`;
export const API_LEADERSHIP_EXPERIENCES = (userId: number) =>
  `${API_BASE_URL}users/${userId}/leadership_experiences`;
export const API_ADD_LEADERSHIP_EXPERIENCES = `${API_BASE_URL}users/leadership_experiences`;
export const API_UPDATE_DELETE_LEADERSHIP_EXPERIENCES = (id: number) =>
  `${API_BASE_URL}users/leadership_experiences/${id}`;
export const API_EXPERIENCES = `${API_BASE_URL}users/experiences`;
export const API_ACHIEVEMENTS = `${API_BASE_URL}users/achievements`;
export const API_DIGITAL_CV_PROGRESS = `${API_MY_PROFILE}/digital_cv_progress`;
export const API_USER_TALENT_POOL = `${API_MY_PROFILE}/talent_pool`;
export const API_CHANGE_USER_EMAIL = `${API_MY_PROFILE}/change_email`;
export const API_USER_TALENT_POOL_DOWNLOAD = `${API_USER_TALENT_POOL}/download`;
export const API_COURSES = `${API_BASE_URL}courses`;
export const API_COURSES_RECOMMENDATIONS = `${API_COURSES}/recommendations`;
export const API_COURSE_CONFIGS = `${API_BASE_URL}course_configs`;
export const API_COURSE = {
  all_courses: API_COURSES,
  course_detail: (course_id: number) => `${API_COURSES}/${course_id}`,
  enrolled_courses: `${API_COURSES}?state=enrolled`,
  completed_courses: `${API_COURSES}?state=completed`,
};
export const API_COURSE_INSIGHTS = `${API_BASE_URL}course/insights`;
export const API_COURSE_INSIGHTS_DETAIL = `${API_COURSE_INSIGHTS}/detail`;
export const API_COURSE_INSIGHTS_COMPETENCY = `${API_COURSE_INSIGHTS}/competency`;
export const API_COURSE_INSIGHTS_USERS = `${API_COURSE_INSIGHTS}/users`;
export const API_COURSE_INSIGHTS_DIVISION = `${API_COURSE_INSIGHTS}/division`;
export const API_COURSE_INSIGHTS_DOWNLOAD = `${API_COURSE_INSIGHTS}/download`;
export const API_COURSE_INSIGHTS_OVERVIEW = `${API_COURSE_INSIGHTS}`;
export const API_COURSE_INSIGHTS_COURSE_TYPES = `${API_COURSE_INSIGHTS}/course_types`;
export const API_COURSE_INSIGHTS_DETAILS = `${API_COURSE_INSIGHTS}/detail`;
export const API_COURSE_INSIGHTS_ENROLLED_USERS = `${API_COURSE_INSIGHTS}/enrolled_users`;

export const API_HOMEWORK_QUESTION = `${API_BASE_URL}homework_question`;
export const API_HOMEWORK_QUESTION_TAGGING = `${API_BASE_URL}homework_question/taggings`;
export const API_HOMEWORK_QUESTIONS = `${API_BASE_URL}homework_questions`;
export const API_USER_HOMEWORK_QUESTIONS = `${API_BASE_URL}user_homework_questions`;
export const API_ANSWER_OPTIONS = `${API_BASE_URL}answer_options`;
export const API_ANSWERS = `${API_BASE_URL}answers`;
export const API_ASSESSMENT = `${API_BASE_URL}assessment`;
export const API_ASSESSMENTS_IMPORT_CSV = `${API_ASSESSMENT}/items/import/csv`;
export const API_ASSESSMENTS_PROGRESS = `${API_ASSESSMENT}/progress`;
export const API_ASSESSMENTS_SCORE = (id: number) => `${API_ASSESSMENT}/${id}/scores`;
export const API_ASSESSMENT_ASPECTS = `${API_ASSESSMENT}/aspects`;
export const API_ASSESSMENT_ANSWERS = `${API_ASSESSMENT}/answers`;
export const API_ASSESSMENT_FEEDBACKS = `${API_ASSESSMENT}/feedbacks`;
export const API_ASSESSMENT_RESULTS = `${API_ASSESSMENT}/results`;
export const API_ASSESSMENT_SUMMARY = `${API_ASSESSMENT}/summary`;
export const API_ASSESSMENT_QUESTIONS = `${API_ASSESSMENT}/questions`;
export const API_ASSESSMENT_QUESTION_CONVERT = `${API_ASSESSMENT}/items/question/convert`;
export const API_ASSESSMENT_SHOW_OPTIONS = `${API_ASSESSMENT_ASPECTS}/show_options`;
export const API_SCORECARD = `${API_BASE_URL}assignment_scores`;
export const API_POST_ASSIGNMENT_SCORES = (id: number) =>
  `${API_BASE_URL}assignment_scores/${id}/submit_scores`;
export const API_MODULE_SESSIONS = `${API_BASE_URL}module_sessions`;
export const API_CURRENT_SERVER_TIME = `${API_BASE_URL}current_time`;
export const API_COURSE_MODULES = `${API_BASE_URL}course_modules`;
export const API_ATTENDANCE_HISTORIES = `${API_BASE_URL}attendance_histories`;
export const API_ATTENDANCE_HISTORIES_SUMMARY = `${API_BASE_URL}attendance_histories/summary`;
export const API_ASSIGNMENT_HISTORIES_SUMMARY = `${API_BASE_URL}assignment_scores/summary`;
export const API_PORTFOLIO = `${API_BASE_URL}portfolios`;
export const API_FINAL_PROJECTS = `${API_BASE_URL}projects`;
export const API_FINAL_PROJECT_SUBMISSIONS = `${API_BASE_URL}final_project_submissions`;
export const API_USER_MODULE_SESSIONS = `${API_BASE_URL}user_module_sessions`;
export const API_USER_COURSES = `${API_BASE_URL}user_courses`;
export const API_USER_COURSES_DETAIL = `${API_BASE_URL}user_courses/detail`;
export const API_USER_COURSES_GRANT_ROLE = `${API_BASE_URL}user_courses/grant_role`;
export const API_USER_COURSES_REVOKE_ROLE = `${API_BASE_URL}user_courses/revoke_role`;
export const API_USER_COURSE_COUNSELING = `${API_BASE_URL}user_course_counselings`;
export const API_FINAL_SCORING = `${API_BASE_URL}final_scorings`;
export const API_FINAL_SCORING_METRICS = `${API_BASE_URL}final_scoring_metrics`;
export const API_FINAL_SCORING_METRICS_BULK_UPSERT = `${API_FINAL_SCORING_METRICS}/bulk_upsert`;
export const API_USER_COURSE = `${API_BASE_URL}user_course`;
export const API_BEHAVIOUR_SCORINGS = `${API_BASE_URL}behaviour_scorings`;
export const API_MENTORING_GROUPS = `${API_BASE_URL}mentoring_groups`;
export const API_SCORING_TEMPLATES = `${API_BASE_URL}scoring_templates`;
export const API_BEHAVIOURS = `${API_BASE_URL}behaviours`;
export const API_COMPETENCIES = `${API_BASE_URL}competencies`;
export const APU_COMPETENCIES_SUB_COMP_COUNT = `${API_COMPETENCIES}/sub_competency_count`;
export const API_SUB_COMPETENCIES = `${API_BASE_URL}sub_competencies`;
export const API_SPECIALIZATION = `${API_BASE_URL}specializations`;
export const API_BLOOM_TAXONOMIES = `${API_BASE_URL}bloom_taxonomies`;
export const API_INDUSTRY_CATEGORIES = `${API_BASE_URL}industry_categories`;
export const API_USER_MENTORING_GROUPS = `${API_BASE_URL}user_mentoring_groups`;
export const API_SURVEYS = `${API_BASE_URL}surveys`;
export const API_SURVEYS_V2 = `${API_BASE_URL_2}surveys`;
export const API_USER_SURVEYS_ONGOING = `${API_BASE_URL}user_surveys/ongoing`;
export const API_SURVEYS_REMIND_ME = (surveyId: number) =>
  `${API_SURVEYS}/${surveyId}/remind_me_later`;
export const API_USER_SURVEYS_ANSWER = (surveyId: number) =>
  `${API_BASE_URL}user_surveys/${surveyId}`;
export const API_ANSWER_SURVEY = (surveyId: number, surveyComponentId: number) =>
  `${API_USER_SURVEYS_ANSWER(surveyId)}/questions/${surveyComponentId}`;
export const API_SURVEY_ANSWERS = `${API_BASE_URL}survey_answers`;
export const API_SURVEY_TEMPLATES = `${API_BASE_URL}survey_templates`;
export const API_HOMEWORK_OPTIONS = (homeworkQuestionId: number) =>
  `${API_HOMEWORK_QUESTIONS}/${homeworkQuestionId}/homework_options`;
export const API_ANSWER_FEEDBACKS = (homeworkQuestionId: number) =>
  `${API_HOMEWORK_QUESTIONS}/${homeworkQuestionId}/answer_feedbacks`;
export const API_PRESIGNED_URL = `${API_BASE_URL}uploads/presign`;
export const API_PRESIGNED_URL_NOT_AUTH = `${API_BASE_URL}uploads/presign_no_auth`;
export const API_DOCUMENTS = `${API_BASE_URL}user_documents`;
export const API_HIRING_PROCESSES = `${API_BASE_URL}hiring_processes`;
export const API_HIRING_PROCESSES_CONFIRM_INTERVIEW = `${API_HIRING_PROCESSES}/confirm_interview`;
export const API_HIRING_PROCESSES_CONFIRM_OFFERING = `${API_HIRING_PROCESSES}/confirm_offering`;
export const API_HIRING_PROCESSES_CONFIRM_MEDICAL_CHECKUP = `${API_HIRING_PROCESSES}/confirm_medical_checkup`;
export const API_EXTERNAL_COURSES = `${API_BASE_URL}users/external_courses`;
export const API_USER_REMARKS = `${API_BASE_URL}user_remarks`;

export const API_USER_INVOICES = `${API_BASE_URL}user_invoices`;
export const API_USER_INVOICES_DETAILS_BY_OBJECT = `${API_BASE_URL}user_invoice/details_by_object`;
export const API_BULK_DUPLICATES_VWXES = `${API_BASE_URL}/virtual_working_experience/bulk_duplicates`;
export const API_USER_INVOICES_VWXES = `${API_USER_INVOICES}/vwxes`;
export const API_USER_INVOICES_JAP = `${API_USER_INVOICES}/jap`;
export const API_USER_INVOICES_LATEST = `${API_USER_INVOICES}/latest`;
export const API_USER_INSTALLMENTS = `${API_BASE_URL}user_installments`;
export const API_PROMO_CODES = `${API_BASE_URL}promo_codes`;
export const API_PROMO_CODES_REDEEM = `${API_BASE_URL}promo_codes/redeem`;
export const API_PROMO_CODES_REFERRAL_VALIDATE = `${API_BASE_URL}promo_codes/validate`;
export const API_PROMO_CODES_REFERRAL = `${API_BASE_URL}promo_codes/referral`;
export const API_JOB_ROLES = `${API_BASE_URL}job_roles`;
export const API_JOB_ROLE_GROUPS = `${API_BASE_URL}job_role_groups`;
export const API_VWXES = `${API_BASE_URL}vwxes`;
export const API_VWXES_RECOMMENDATIONS = `${API_VWXES}/recommendations`;
export const API_VWXES_SEND_REMINDERS = `${API_VWXES}/send_reminders`;
export const API_VWXES_ENROLL = `${API_VWXES}/enroll`;
export const API_VWXES_QUOTA = `${API_VWXES}/quota`;
export const API_VIRTUAL_WORKING_EXPERIENCE = `${API_BASE_URL}virtual_working_experience`;
export const API_VIRTUAL_WORKING_EXPERIENCE_REQUESTS = `${API_VIRTUAL_WORKING_EXPERIENCE}/requests`;
export const API_VIRTUAL_WORKING_EXPERIENCE_TASK = `${API_VIRTUAL_WORKING_EXPERIENCE}/tasks`;
export const API_VIRTUAL_WORKING_EXPERIENCE_TASK_COMPONENTS = `${API_VIRTUAL_WORKING_EXPERIENCE}/task_components`;
export const API_VIRTUAL_WORKING_EXPERIENCE_REWARDS = `${API_VIRTUAL_WORKING_EXPERIENCE}/vwx_rewards`;
export const API_VIRTUAL_WORKING_EXPERIENCE_SECTIONS = `${API_VIRTUAL_WORKING_EXPERIENCE}/sections`;
export const API_USER_VWXES_TALENT_ACCESS_TOKEN = `${API_VIRTUAL_WORKING_EXPERIENCE}/talent_access_tokens/talent_share_access_token`;
export const API_USER_VWXES_VERIFY_TALENT_ACCESS_TOKEN = `${API_VIRTUAL_WORKING_EXPERIENCE}/talent_access_tokens/verify_talent_access_token`;
export const API_TALENT_RECOMMENDATIONS = `${API_BASE_URL}talent_recommendations`;
export const API_USER_QUESTION = `${API_BASE_URL}user_questions`;
export const API_INSTALLMENT_REQUESTS = `${API_BASE_URL}installment_requests`;
export const API_COURSE_REWARDS = `${API_BASE_URL}course_rewards`;
export const API_COURSE_REWARD_REMIND_ME = (courseRewardId: number) =>
  `${API_BASE_URL}course_rewards/${courseRewardId}/remind_me`;
export const API_USER_REWARDS = `${API_BASE_URL}user_rewards`;
export const API_EDUCATION_LEVELS = `${API_BASE_URL}education_levels`;
export const API_JOB_VACANCIES = `${API_BASE_URL}job_vacancies`;
export const API_JOB_VACANCIES_MASS_UPDATE = `${API_JOB_VACANCIES}/mass_updates`;
export const API_JOB_VACANCIES_INSIGHTS = `${API_JOB_VACANCIES}/insights`;
export const API_JOB_VACANCIES_APPLICANT_SOURCES = `${API_JOB_VACANCIES}/applicant_sources`;
export const API_JOB_VACANCIES_STATISTICS = `${API_JOB_VACANCIES}/statistics`;
export const API_JOB_VACANCIES_RECOMMENDATIONS = `${API_JOB_VACANCIES}/recommendations`;
export const API_USER_JOB_VACANCIES = `${API_BASE_URL}user_job_vacancies`;
export const API_USER_JOB_VACANCIES_PAGE_INFO = `${API_USER_JOB_VACANCIES}/page_info`;
export const API_USER_JOB_VACANCIES_SUBMISSION_PIPELINES = `${API_USER_JOB_VACANCIES}/submission_pipelines`;
export const API_USER_JOB_VACANCIES_HISTORIES = `${API_BASE_URL}user_job_vacancies/histories`;
export const API_USER_JOB_VACANCIES_RECRUITMENT_FUNNELS = `${API_USER_JOB_VACANCIES}/recruitment_funnels`;
export const API_USER_JOB_VACANCIES_APPLIED = `${API_USER_JOB_VACANCIES}/applied`;
export const API_USER_JOB_VACANCIES_COMPARISON = `${API_BASE_URL}user_job_vacancies/comparison`;
export const API_LOCATIONS = `${API_BASE_URL}locations`;
export const API_UNIVERSITIES = `${API_BASE_URL}universities`;
export const API_UNIVERSITY_MAJORS = `${API_BASE_URL}university_majors`;
export const API_USER_VWX_TASKS_SUMMARY = `${API_BASE_URL}user_vwx_tasks/summary`;
export const API_SKILLS = `${API_BASE_URL}skills`;
export const API_PARTNERS = `${API_BASE_URL}partners`;
export const API_PARTNERS_RECRUITERS = `${API_PARTNERS}/recruiters`;
export const API_PROVINCES = `${API_BASE_URL}provinces`;
export const API_LOGIN_PARTNER = `${API_LOGIN}/partner`;
export const API_JOB_GUARANTEES = `${API_BASE_URL}job_guarantees`;
export const API_USER_VWXES = `${API_BASE_URL}user_vwxes`;
export const API_USER_COMPETENCIES = `${API_USER_VWXES}/talent_competency_details`;
export const API_USER_VWXES_TALENT_POOL = `${API_USER_VWXES}/talent_pools`;
export const API_SAVED_CANDIDATES_COUNT = `${API_USER_VWXES}/saved_candidates_count`;
export const API_TALENT_COUNT = `${API_USER_VWXES}/talent_count`;
export const API_ALL_TALENT_COUNT = `${API_USER_VWXES}/all_talent_count`;
export const API_USER_VWX_PARTNERS = `${API_BASE_URL}user_vwx_partners`;
export const API_IDENTIFY_USER = `${API_BASE_URL}users/identify`;
export const API_CAREER_PATHS = `${API_BASE_URL}career_paths`;
export const API_USER_CAREER_PATHS = `${API_BASE_URL}user_career_paths`;
export const API_RECOMMENDED_TALENTS = `${API_USER_CAREER_PATHS}/recommended_talents`;
export const API_SELECT_USER_CAREER_PATHS = `${API_USER_CAREER_PATHS}/select_path`;
export const API_TALENT_POOLS_DOWNLOAD = `${API_BASE_URL}user_vwxes/talent_pools/download`;
export const API_PARTNER_TEAMS = `${API_BASE_URL}partner_teams`;
export const API_SEND_VERIFICATION = `${API_BASE_URL}users/send_verification`;
export const API_VERIFY_TOKEN = `${API_BASE_URL}users/verify_token`;
export const API_USER_VWXES_PARTNER = `${API_BASE_URL}user_vwx_partners`;
export const API_ORGANIZATION = `${API_BASE_URL}organizations/default`;
export const API_CONSULTATION_TRAININGS = `${API_BASE_URL}consultation_trainings`;
export const API_CONSULTATION_HIRINGS = `${API_BASE_URL}consultation_hirings`;
export const API_COMPANY_REGISTRATION_REQUEST = `${API_BASE_URL}company_registration_requests`;
export const API_BUNDLING_CODES = `${API_BASE_URL}bundling_codes`;
export const API_USER_PREFERENCES = `${API_BASE_URL}user_preferences`;
export const API_MANAGE_USER_GROUP = `${API_BASE_URL}user_groups`;
export const API_MANAGE_USER_STATISTIC = `${API_BASE_URL}user_groups/count_non_student`;
export const API_ASSESSMENT_START_EXTRA_TIME = `${API_BASE_URL}assessment/start_extra_time`;
export const API_ASSESSMENT_ITEM = `${API_BASE_URL}assessment/items`;
export const API_ASSESSMENT_ITEM_CONFIG = `${API_BASE_URL}assessment/configs`;
export const API_OPENAI_STREAM_RESPONSE = `${API_BASE_URL}ai/openai/stream_response`;
export const API_OPENAI_CHATS = `${API_BASE_URL}ai/openai/chats`;
export const API_OPENAI_MESSAGES = (id?: number) => `${API_BASE_URL}ai/openai/chats/${id}/messages`;
export const API_USER_NOTIFICATIONS = `${API_BASE_URL}user_notifications`;

export const API_VERIFY_USER_TOKEN = `${API_BASE_URL}user_tokens/verify`;
export const API_VERIFY_ASSESSMENT_INVITATION = `${API_BASE_URL}user_tokens/vacancy_assessment_invitation`;
export const API_VERIFY_IDENTITY_DOCUMENT = `${API_BASE_URL}user_tokens/uploaded_document`;
export const API_VERIFY_UPLOADED_DOCUMENT = `${API_BASE_URL}user_tokens/upload_verification`;
export const API_SEND_MAGIC_LINK = `${API_BASE_URL}user_tokens/send_magic_link`;
export const API_SEND_USER_VERIFICATION = `${API_BASE_URL}user_tokens/send_verification`;

export const API_REDEEM_CODE_PRAKERJA = `${API_BASE_URL}promo_codes/redeem_external`;
export const API_VALIDATE_PRAKERJA = `${API_BASE_URL}prakerja/validate`;
export const API_CALLBACK_PRAKERJA = `${API_BASE_URL}prakerja/callback`;
export const API_CALLBACK_STATUS = (voucher = "") => `${API_BASE_URL}prakerja/status/${voucher}`;
export const API_FEATURES = `${API_BASE_URL}features`;
export const API_FEATURES_LATEST = `${API_FEATURES}/latest`;
export const API_FEATURES_CONFIG = `${API_FEATURES}/config`;
export const API_USER_FEATURE_ONBOARDINGS = `${API_BASE_URL}user_feature_onboardings`;
export const API_TRIGGER_EMAIL_FREECLASS = (id: string) =>
  `${API_BASE_URL}courses/${id}/bootcamp_trial_mail`;
export const API_WEB_CONFIGS = `${API_BASE_URL}web_configs`;
export const API_USERS_ME = `${API_BASE_URL_2}users/me`;
export const API_DIGITAL_CV = `${API_BASE_URL}digital_cvs/`;
export const API_DIGITAL_CV_ADDRESS = `${API_DIGITAL_CV}address_data`;
export const API_DIGITAL_CV_SETTINGS = `${API_DIGITAL_CV}settings`;
export const API_DIGITAL_CV_VISITOR_COUNT = `${API_DIGITAL_CV}visitor_count`;
export const API_DIGITAL_CV_SIMILAR_ROLE = `${API_DIGITAL_CV}similar_role_users`;
export const API_JAP_CAMPUS_CHECK_STATUS = `${API_BASE_URL}jap_campus/check_status`;
export const API_JAP_CAMPUS_PERIOD = `${API_BASE_URL}jap_campus/period`;
export const API_CERTIFICATE_PUBLIC = (courseId: string) =>
  ` ${API_BASE_URL}courses/${courseId}/certificates`;
export const API_USER_COMPETENCIES_LIST_VALIDATED = `${API_BASE_URL}user_competencies/list_validated`;
export const API_USER_COMPETENCIES_LIST_NOT_VALIDATED = `${API_BASE_URL}user_competencies/list_not_validated`;
export const API_COMPANY_ASSESSMENT_TEMPLATES = `${API_BASE_URL}company_assessment_templates`;
export const API_COMPANY_ASSESSMENT_TEMPLATE_CONNECT = `${API_BASE_URL}company_assessment_templates/connect`;
export const API_JOB_VACANCY_ASSESSMENTS = `${API_BASE_URL}job_vacancy_assessments`;
export const API_JOB_VACANCY_ASSESSMENTS_INTEGRATED_PIPELINE = `${API_JOB_VACANCY_ASSESSMENTS}/integrated_pipeline`;
export const API_JOB_VACANCY_ASSESSMENT_USERS = `${API_BASE_URL}user_job_vacancy_assessments`;
export const API_JOB_VACANCY_ASSESSMENT_VERIFY_TOKEN = `${API_BASE_URL}user_job_vacancy_assessments/verify_tokens`;
export const API_JOB_VACANCY_ASSESSMENT_SCORES = `${API_JOB_VACANCY_ASSESSMENT_USERS}/scores`;
export const API_USER_ASSESSMENT_SCORES = `${API_BASE_URL}assessment/scores`;
export const API_USER_ASSESSMENT_REPORT = (id: string) => `${API_BASE_URL}assessment/${id}/report`;
export const API_PARTNER_SAVED_TALENTS = `${API_BASE_URL}partner_saved_talents`;
export const API_STIMULI = (id?: number) => `${API_BASE_URL}stimuli${id ? "/" + id : ""}`;
export const API_PROGRAM_REGISTRATION = `${API_BASE_URL}program_registrations/`;
export const API_PROGRAM_REGISTRATION_IDENTIFY = `${API_PROGRAM_REGISTRATION}identify`;
export const API_PROCTORING = `${API_BASE_URL}user_proctor_logs`;
export const API_PROCTORING_REPORT = `${API_BASE_URL}user_proctor_reports`;
export const API_USER_COURSE_REVIEW = `${API_BASE_URL}user_course_reviews`;
export const API_USER_COURSE_REVIEW_STATISTICS = (course_id?: number) =>
  `${API_BASE_URL}user_course_reviews/review_statistics/${course_id}`;
export const API_VACANCY_QUESTIONS = `${API_BASE_URL}vacancy_questions`;
export const API_VACANCY_ADDITIONAL_QUESTIONS_ANSWER = `${API_VACANCY_QUESTIONS}/answer`;
export const API_VACANCY_QUESTIONS_UPSERT = `${API_VACANCY_QUESTIONS}/upsert`;
export const API_VACANCY_QUESTIONS_ANSWER = (id: number) =>
  `${API_BASE_URL}vacancy_questions/${id}/answers`;
export const API_HIRING_PIPELINES = `${API_BASE_URL}hiring_pipelines`;
export const API_HIRING_PIPELINES_BULK_UPSERT = `${API_HIRING_PIPELINES}/bulk_upsert`;
export const API_HIRING_PIPELINES_UPSERT = `${API_HIRING_PIPELINES}/upsert`;
export const API_HIRING_PIPELINES_COLUMN_FILTERS = `${API_BASE_URL}hiring_pipeline_column_filters`;
export const API_JOB_VACANCY_RECRUITERS = `${API_BASE_URL}job_vacancy_recruiters/upsert`;
export const API_USER_HIRING_PIPELINES = `${API_BASE_URL}user_hiring_pipelines`;
export const API_USER_HIRING_PIPELINE_SUBMISSION = `${API_BASE_URL}user_hiring_pipeline_submissions/upload`;
export const API_USER_HIRING_PIPELINE_FEEDBACKS = `${API_BASE_URL}user_hiring_pipeline_feedbacks`;
export const API_OPENAI_ASSISTANT = `${API_BASE_URL}ai/openai/assistant_runs`;
export const API_ASSIGNMENT_LEADERBOARD = `${API_BASE_URL}assignment_scores/leaderboard`;
export const API_ASSIGNMENT_TUTOR = `${API_BASE_URL}assignment_scores/tutor_list`;
export const API_ASSIGNMENT_SUMMARY = `${API_BASE_URL}assignment_scores/summary`;
export const API_ASSIGNMENT_CHART = `${API_BASE_URL}assignment_scores/weekly_summary`;
export const API_SHARE_VACANCY_TOKENS = `${API_BASE_URL}shared_vacancy_tokens`;
export const API_USER_VACANCY_BATCH_UPDATES = `${API_BASE_URL}user_vacancy_batch_updates`;
export const API_MAILER_TEMPLATES = `${API_BASE_URL}mailer_templates`;
export const API_SEND_TEST_EMAIL = (id: number) => `${API_MAILER_TEMPLATES}/${id}/send_test_email`;
export const API_IMPORT_USERS = `${API_BASE_URL}users/imports`;
export const API_LICENSE = `${API_BASE_URL}licenses`;
export const API_PARTNER_PLACEMENT = `${API_BASE_URL}partner_placements`;
export const API_INVITE_AND_ASSESS = `${API_BASE_URL}invite_assesses`;

export const API_JOB_VACANCY_COLUMN_SETTING = (id: number, state: string) =>
  `${API_BASE_URL}job_vacancies/${id}/column_settings/${state}`;
export const API_JOB_VACANCY_COLUMN_SETTING_GROUP = (id: number, state: string) =>
  `${API_BASE_URL}job_vacancies/${id}/column_settings/${state}/grouped`;
export const API_JOB_VACANCY_COLUMN_FILTERS = (id: number, state: string) =>
  `${API_BASE_URL}job_vacancies/${id}/column_filters/${state}`;
export const MATCH_MAKING_CONFIG = (id: number | string) =>
  `${API_BASE_URL}job_vacancies/${id}/match_making_config`;

export const API_JOB_VACANCY_TAGGINGS = `${API_BASE_URL}job_vacancy_taggings`;
export const API_ORGANIZATION_EXPERIENCES = `${API_BASE_URL}users/organization_experiences`;
export const API_ORGANIZATION_EXPERIENCES_LIST = (userId: number) =>
  `${API_BASE_URL}users/${userId}/organization_experiences`;
export const API_USER_VACANCY_ANOTHER_SOURCE_IMPORTS = `${API_BASE_URL}user_vacancy_another_source_imports`;
export const API_USER_VACANCY_ANOTHER_SOURCE_IMPORT_RESULT = (id: string) =>
  `${API_BASE_URL}user_vacancy_another_source_imports/${id}`;
export const API_ASSESSMENT_CONNECT = `${API_BASE_URL}assessment/unconnected`;

export const API_FEEDBACK_TEMPLATES = `${API_BASE_URL}feedback_templates`;
export const API_USER_FEEDBACKS = `${API_BASE_URL}user_feedbacks`;

export const API_TALENT_INTELLIGENCE = `${API_BASE_URL}ti_analytics`;
export const API_TALENT_INTELLIGENCE_PROJECTS = `${API_TALENT_INTELLIGENCE}/projects`;
export const API_TALENT_INTELLIGENCE_PROJECT_VARIABLES = `${API_TALENT_INTELLIGENCE}/variables`;
export const API_TALENT_INTELLIGENCE_PROJECT_GROUPS = `${API_TALENT_INTELLIGENCE}/groups`;
export const API_TALENT_INTELLIGENCE_PROJECT_FILTERS = `${API_TALENT_INTELLIGENCE}/filters`;
export const API_TALENT_INTELLIGENCE_PROJECT_COMPARISONS = `${API_TALENT_INTELLIGENCE}/comparisons`;
export const API_TALENT_INTELLIGENCE_TALENT_DISTRIBUTION = `${API_TALENT_INTELLIGENCE}/talent_distribution`;

export const API_LGD_BASE_URL = `${API_BASE_URL}ai/lgd`;
export const API_LGD_ANALYSIS = `${API_LGD_BASE_URL}/analyze`;
export const API_LGD_TRANSCRIPTION = (id: string) => `${API_LGD_BASE_URL}/${id}/transcript`;
export const API_LGD_ANALYSIS_RESULT = (id: string) => `${API_LGD_BASE_URL}/${id}/result`;
export const API_LGD_ANALYSIS_DETAIL = (id: string) => `${API_LGD_BASE_URL}/${id}/detail`;

export const API_VIDEO_ANALYZER = `${API_BASE_URL}ai/video_analyzer`;

export const API_PARTNER_ATTRIBUTES = (key: string) =>
  `${API_BASE_URL}partner_attributes/${key}/values`;
export const API_PARTNER_ATTRIBUTES_ALL = `${API_BASE_URL}partner_attributes/all`;
export const API_ASSESSMENT_PROJECTS = `${API_BASE_URL}ti_assessments/projects`;
export const API_ASSESSMENT_PROJECTS_DETAIL = (id: number) =>
  `${API_BASE_URL}ti_assessments/projects/${id}`;
export const API_ASSESSMENT_PROJECTS_ASSESSMENTS = (id: number) =>
  `${API_BASE_URL}ti_assessments/projects/${id}/assessments`;
export const API_TALENT_INTELLIGENCE_IDP = `${API_BASE_URL}ti_idp`;
export const API_TALENT_INTELLIGENCE_IDP_PROJECTS = `${API_TALENT_INTELLIGENCE_IDP}/projects`;
export const API_TALENT_INTELLIGENCE_USER_IDP = `${API_TALENT_INTELLIGENCE_IDP}/users/`;
export const API_TALENT_INTELLIGENCE_COMPETENCY_DISTRIBUTIONS = `${API_BASE_URL}ti/competencies/distributions`;
export const API_TALENT_INTELLIGENCE_COMPETENCY_OVERALL = `${API_BASE_URL}ti/competencies/overall`;
export const API_TALENT_INTELLIGENCE_COMPETENCY_USERS = `${API_BASE_URL}ti/competencies/users`;
export const API_TALENT_INTELLIGENCE_COMPETENCY_HEATMAP = `${API_BASE_URL}ti/competencies/heatmap`;
export const API_TALENT_INTELLIGENCE_COMPETENCY_FILTERS = `${API_BASE_URL}ti/competencies/filters`;

export const RECORDINGS_API = `${API_BASE_URL}recordings`;

export const API_BLACKLISTS = `${API_BASE_URL}partner_blacklisted_candidates`;
export const API_USER_BLACKLIST_HISTORY = (userId: number) =>
  `${API_BASE_URL}users/${userId}/blacklist_histories`;

export const API_JOB_APPLICATION_RESTRICTIONS = (partnerId: number) =>
  `${API_PARTNERS}/${partnerId}/job_application_restrictions`;
